import { FormLabel } from '@mui/material'
import { CheckBox } from 'entities/ChekBox'
import { Input } from 'entities/Input'
import { useConfigStore } from 'shared/store/configSlice'

export const CheckboxesTR = () => {
  const email = useConfigStore().config?.tableReservationConfig?.email
  const showNote = useConfigStore().config?.tableReservationConfig?.showNote
  const showRoom = useConfigStore().config?.tableReservationConfig?.showRoom
  const showAllergens = useConfigStore().config?.tableReservationConfig?.showAllergens
  const updateTableReservationConfig = useConfigStore().updateTableReservationConfig

  const handleUpdateValue =
    (param: 'showAllergens' | 'showRoom' | 'showNote' | 'email') => (value: boolean | string) => {
      updateTableReservationConfig({ [param]: value })
    }

  return (
    <div>
      <FormLabel id='additional_options-label'>Additional options</FormLabel>
      <CheckBox
        checked={Boolean(showAllergens)}
        handleChange={handleUpdateValue('showAllergens')}
        label='Show Allergens'
      />
      <CheckBox
        checked={Boolean(showRoom)}
        handleChange={handleUpdateValue('showRoom')}
        label='Show Room'
      />
      <CheckBox
        checked={Boolean(showNote)}
        handleChange={handleUpdateValue('showNote')}
        label='Show Note'
      />
      <Input
        label='Notifications Email'
        defaultValue={email}
        onBlur={handleUpdateValue('email')}
        fullWidth
      />
    </div>
  )
}
